import rootStore, { RootStoreModel } from './root.store';

export const createStore = (): RootStoreModel =>
  rootStore.create({
    transaction: {
      list: [],
      pagination: { links: {} },
    },
    detail: {},
    alert: {},
    auth: { currentUser: {} },
    invoice: {},
    isLoading: false,
    invitations: { list: [] },
    users: { list: [] },
    otp: {},
    recurringRequest: {
      list: [],
      pagination: {},
    },
    recurringFile: {
      list: [],
      pagination: {},
    },
    recurringDetail: {},
    recurringTransaction: {
      list: [],
      pagination: {},
    },
  });

export * from './root.store';
export default createStore;
